import React from "react";
import MultiStepCardViewer from "../../../srs/MultiCardStepViewer";
import { Box, Button } from "@mui/material";
import languageLearningApi from "../../middleware/languageLearningApi";

// Helper function: convert a sentence payload into multi-step card data
function convertSentenceToCardData(sentence) {
  const steps = [];
  
  const grammarContent = sentence.grammarConcepts
    .map((g) => {
      const details = (g.details || [])
        .map((d) => `  - **${d.key}**: ${d.value}`)
        .join("\n");
      const examples = (g.examples || [])
        .map((ex) => `  - ${ex.foreignSentence} / ${ex.nativeSentence}`)
        .join("\n");
      return `**${g.concept}**\n${g.description}\n\n*Details:*\n${details}\n\n*Examples:*\n${examples}`;
    })
    .join("\n\n");
  steps.push({ content: `**Grammar Concepts:**\n\n${grammarContent}`, images: [] });
  
  return {
    _id: sentence._id,
    title: sentence.text, // Use the actual sentence text as the title
    steps,
    answer: sentence.translation,
    createdAt: sentence.createdAt
  };
}

const SentenceViewer = ({ sentence, onClose }) => {
  const cardData = convertSentenceToCardData(sentence);

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0,0,0,0.5)",
        zIndex: 1000,
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}
    >
      <Box
        sx={{
          width: { xs: "90%", md: "80%" },
          background: "white",
          borderRadius: 2,
          overflow: "hidden",
          boxShadow: 24,
          p: 2
        }}
      >
        <MultiStepCardViewer cardData={cardData} />
        <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
          <Button variant="contained" color="primary" onClick={onClose}>
            Close Viewer
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default SentenceViewer;
